import { render, staticRenderFns } from "./EditMessageModal.vue?vue&type=template&id=6458394a&scoped=true"
import script from "./EditMessageModal.vue?vue&type=script&lang=js"
export * from "./EditMessageModal.vue?vue&type=script&lang=js"
import style0 from "./EditMessageModal.vue?vue&type=style&index=0&id=6458394a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6458394a",
  null
  
)

export default component.exports